import api from './axios';

export const getMyLeaves = () => api.get('/leaves/my');
export const createLeaveRecord = (data) => api.post('/leaves', data);
export const getLeaveRecords = (params) => api.get('/leaves', { params });
export const getLeaveSummary = (params) => api.get('/leaves/summary', { params });
export const decideLeaveRecord = (id, data) => api.patch(`/leaves/${id}/decide`, data);
export const deleteLeaveRecord = (id) => api.delete(`/leaves/${id}`);
